import apiClient from './apiClient';

export const katalogApi = {
  // CRUD
  getPositionen: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.kategorie) params.append('kategorie', filters.kategorie);
    if (filters.aktiv !== undefined) params.append('aktiv', filters.aktiv);
    if (filters.search) params.append('search', filters.search);

    const response = await apiClient.get(`/katalog?${params}`);
    return response.data;
  },

  getPosition: async (id) => {
    const response = await apiClient.get(`/katalog/${id}`);
    return response.data;
  },

  createPosition: async (data) => {
    const response = await apiClient.post('/katalog', data);
    return response.data;
  },

  updatePosition: async (id, data) => {
    const response = await apiClient.put(`/katalog/${id}`, data);
    return response.data;
  },

  deletePosition: async (id) => {
    const response = await apiClient.delete(`/katalog/${id}`);
    return response.data;
  },

  // Bulk-Aktionen
  bulkAction: async (ids, action) => {
    const response = await apiClient.patch('/katalog/bulk', { ids, action });
    return response.data;
  },

  // Import/Export
  exportCSV: () => {
    const token = localStorage.getItem('token');
    return `${apiClient.defaults.baseURL}/katalog/export/csv?token=${token}`;
  },

  importCSV: async (file) => {
    const formData = new FormData();
    formData.append('csv', file);
    const response = await apiClient.post('/katalog/import/csv', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  // Autocomplete
  autocomplete: async (search) => {
    const response = await apiClient.get('/katalog/autocomplete', {
      params: { search }
    });
    return response.data;
  },

  // Kategorien
  getKategorien: async () => {
    const response = await apiClient.get('/katalog/kategorien');
    return response.data;
  }
};

export default katalogApi;
